import React from 'react';

function ConsultaCedula() {
  return <h1>Consulta de Cédula</h1>;
}

export default ConsultaCedula;
